<template>
  <pt-all-order-list class="pt-all-order-list__page"></pt-all-order-list>
</template>

<script>
import PtAllOrderList from 'cps/goods-order/pt-all-order-list/withData'
export default {
  name: 'pt-all-order-list__view',
  components: {
    'pt-all-order-list': PtAllOrderList
  }
}
</script>
